/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const tmdbTitleResultSchema = z.object({
  tmdbId: z.number(),
  title: z.string(),
  year: z.string().nullable(),
  overview: z.string(),
});

export type ITmdbTitleResult = z.infer<typeof tmdbTitleResultSchema>;

export const searchTmdbTitlesResponseSchema = createApiResponseSchema(
  z.array(tmdbTitleResultSchema),
) as import('zod').ZodSchema<IAPI<ITmdbTitleResult[]>>;

export type ISearchTmdbTitlesResponse = IAPI<ITmdbTitleResult[]>;
